import { COURSE_LIST, COURSE_DETAILS } from './../constant/ActionTypes';

export const courseReducer = (state, action) => {
    switch (action.type) {
        case COURSE_LIST:
            return { 
                ...state, 
                courseList: action.payload 
            };
        case COURSE_DETAILS:
            return { 
                ...state, 
                courseDetails: action.payload 
            };
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./contexts/reducer/courseReducer.js